import { z } from 'zod';

export const GameModeKeySchema = z.enum(['GAME_MODE_caverns','GAME_MODE_pvpAuto','GAME_MODE_pvpLive']);

export type GameModeKeyType = `${z.infer<typeof GameModeKeySchema>}`

export default GameModeKeySchema;
